module.exports = __webpack_public_path__ + "img/car_icon04.cc4ad294.png";